import React, { useState, useEffect } from "react";
import yaml from "js-yaml";

export function YamlEditor({ pageDataset, onSave }) {
  const [yamlText, setYamlText] = useState("");

  // Load dataset → YAML when panel opens
  useEffect(() => {
    try {
      setYamlText(yaml.dump(pageDataset));
    } catch (e) {
      console.error("YAML conversion error:", e);
      setYamlText("# Failed to load YAML");
    }
  }, [pageDataset]);

  const handleSave = () => {
    try {
      const json = yaml.load(yamlText);
      onSave(json); // send JSON back up
    } catch (e) {
      alert("Invalid YAML:\n" + e.message);
    }
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <textarea
        value={yamlText}
        onChange={(e) => setYamlText(e.target.value)}
        style={{
          flex: 1,
          width: "90%",
          border: "1px solid #ccc",
          borderRadius: "6px",
          padding: "5px",
          fontSize: "14px",
          fontFamily: "monospace",
          resize: "none"
        }}
      />

      <button onClick={handleSave} className="flat-btn top-btn" style={{ marginTop: "5px" }}>
        💾 Save YAML
      </button>
    </div>
  );
}
